import { gql } from "@apollo/client";

export const CREATE_NEW_TEMPLATE = gql`
  mutation createCsvExtractTemplate($title: String!, $fields: [CsvTemplateFieldInput]!) {
    createCsvExtractTemplate(title: $title, fields: $fields) {
      success
      message
    }
  }
`;